import React, {Component} from 'react';

import { cf } from './cf';
import { ce } from './ce';
import { ic } from './ic';
import { bf } from './bf';

import { iv } from './iv';
import { cp } from './cp';
import cView from './cView';

class cPdtDtl extends cView{

  $id_stgs = {
      b_useCm60: false,
  };

  $cd_stss = {
    s_cm50ｔ110: '', // 商品種別
    s_cm50c310: '', // 商品名
    s_cm50cz10: '10',
    //
    sld_cm60ss: {},
  }

  $clp_loads = () => [
    cp.$cp_load_cm50({
      mode: 'set',
      b_clr: (global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'show') ? false: true,
      cm50_key: global.c?.state.sgcd_pageCmns?.cm50_key,
    }),
  ];

  $cp_ins = () => new Promise( _o_end1 => {
    let _d_vals = {
//      cm50b11k: global.c?.state.sgcd_pageCmns?.cm20_key, // 項目番号
      cm50b11k: global.c?.state.sgcd_pageCmns?.cm20_key, // 項目番号
      cm50c110: '', // 項目番号
    };
    cf.myCB_call_iud({
      ctr: 'ins', 
      elm: 'cm50', 
      d_vals: _d_vals
    })
    .then((_d_cm50s) => {
/*
      cf.myLS_setStt(
        'sgcd_pageCmns',
        bf.p(global.c?.state.sgcd_pageCmns, _next => {
          _next.cm50_key = _d_cm50s._KEY;
        })
      )
      .then(() => {
        _o_end1(_d_cm50s);
      });
*/
      cf.myRN_setCmns({
        cm50_key: _d_cm50s._KEY,
      })
      .then(() => {
        _o_end1(_d_cm50s);
      });
    });
  });

  $clp_upds = () => [
    cp.$cp_upd_cm50(),
    new Promise( async _o_end1 => {
      if (global.c?.$id_stgs.b_usecm60 == true) {
        for await (let [_key, _d_cm60s] of bf.e(global.c?.state.sld_cm60ss)) {
          if (_key.substr(0,3) == 'new') { // 新規登録の場合
            let _d_vals2 = {
              cm60b11k: global.c?.state.sgcd_pageCmns?.cm50_key,
              cm60d110: _d_cm60s.cm60d110,
              cm60d120: _d_cm60s.cm60d120,
              cm60i110: _d_cm60s.cm60i110,
            };
            let _cnd2 = bf.q('')
            await cf.myCB_call_iud({
              ctr: 'ins', 
              elm: 'cm60', 
              d_vals: _d_vals2, 
              cnd: _cnd2
            })
            .then((_d_cm60s)=>{
            })
          }
          else { // 上書きの場合
            let _d_vals3 = {
              cm60d110: _d_cm60s.cm60d110,
              cm60d120: _d_cm60s.cm60d120,
              cm60i110: _d_cm60s.cm60i110,
            };
            let _cnd3 = bf.q('[_KEY]={}'.f(_key))
            await cf.myCB_call_iud({
              ctr: 'upd', 
              elm: 'cm60', 
              d_vals: _d_vals3, 
              cnd: _cnd3
            })
            .then(()=>{
            })
          };
        };
        // 終了日の更新
        let _qry4= bf.q('UPDATE [t_cm60] SET [cm60d120]=(SELECT CASE WHEN (SELECT COUNT(*) FROM [t_cm60] AS A WHERE [cm60b11k]="{}" AND [t_cm60].[cm60d110]<A.[cm60d110])<1 THEN "9999-12-31" ELSE (SELECT TO_CHAR(MIN(TO_DATE([cm60d110], "YYYY-MM-DD")) - 1, "YYYY-MM-DD") FROM [t_cm60] AS A WHERE [cm60b11k]="{}" AND [t_cm60].[cm60d110]<A.[cm60d110]) END) WHERE [cm60b11k]="{}"'.f(
          global.c?.state.sgcd_pageCmns?.cm50_key, 
          global.c?.state.sgcd_pageCmns?.cm50_key, 
          global.c?.state.sgcd_pageCmns?.cm50_key
        ))
        cf.myCB_call_iud('qry', 'cm60', {}, '', _qry4)
        .then(()=>{
          _o_end1();
        })
      }
      else {
        _o_end1();
      };
    }),
  ];    

  //
  render(){
    return (
      <ce.RootDtl
        key={-1}
        b_logo={false}
        b_alwEdit={false}
        b_rhtVsb={true}
        rhtPfx={null}
        onRhtPrs={null}
        b_entBtnVsb={true}
        n_bdyW={ic.gn_maxBdyW}
        d_hdrs={{
          pfx: '商品情報',
          d_leftBtns: {},
        }}
        d_bdys={{
          ld_defss: [
            {
              type:'Pck',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm50t110',
              pfx:'商品種別',
              dd_listItemss:{
                '0':{key:'0', pfx: '未選択'},
              },
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm50c310',
              pfx:'商品名',
              b_mln:false,
            },
            {
              type: 'Clds',
              b_vsb: true,
              b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state: 'sld_cm60ss',
              pfx: '単価',
              dd_defss: {
                cm60d110:{
                  type:'Inp',
                  b_vsb:true,
                  b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
                  pfx:'適用開始日（YYYY-MM-DD）',
                  b_mln:false,
                },
                cm60d120:{
                  type:'Inp',
                  b_vsb:true,
                  b_edt:false,
                  pfx:'適用終了日（YYYY-MM-DD）',
                  b_mln:false,
                },
                cm60i110:{
                  type:'Inp',
                  b_vsb:true,
                  b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
                  pfx:'税込金額',
                  b_mln:false,
                },
              },
            },
          ],
        }}
      />
    );
  }        
}

export default cPdtDtl;
